import React from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "reactstrap";
import { func, bool } from "prop-types";
import { Formik } from "formik";
import { getSecretKeySchema } from "@/util/validationHelper";

const SecretKeySchema = getSecretKeySchema();

function SecretKeyForm({ onSubmit, isBackupForm }) {
  return (
    <Card>
      <Formik
        initialValues={{
          secretKey: "",
          secretKeyRepeat: "",
        }}
        validationSchema={SecretKeySchema}
        validate={values => {
          if (values.secretKey !== values.secretKeyRepeat) {
            return {
              secretKeyRepeat: "Secret keys are not matched",
            };
          }
          return {};
        }}
        onSubmit={onSubmit}>
        {({
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          errors,
          touched,
        }) => (
          <Form onSubmit={handleSubmit}>
            <CardHeader>
              {isBackupForm
                ? "Please input your secret key if you want to make a back-up"
                : "Please input your secret key"}
            </CardHeader>
            <CardBody
              style={{
                height: 175,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}>
              <FormGroup row>
                <Label sm={3}>Secret key</Label>
                <Col sm={9}>
                  <Input
                    type="password"
                    name="secretKey"
                    invalid={Boolean(errors.secretKey)}
                    value={values.secretKey}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    data-cy="secretkey"
                  />
                  {errors.secretKey && (
                    <FormFeedback className="text-alert">
                      {errors.secretKey}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>Repeat secret key</Label>
                <Col sm={9}>
                  <Input
                    type="password"
                    name="secretKeyRepeat"
                    invalid={Boolean(errors.secretKeyRepeat)}
                    value={values.secretKeyRepeat}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    data-cy="secretkey-repeat"
                  />
                  {errors.secretKeyRepeat && touched.secretKeyRepeat && (
                    <FormFeedback>{errors.secretKeyRepeat}</FormFeedback>
                  )}
                </Col>
              </FormGroup>
            </CardBody>
            <CardFooter style={{ display: "flex", justifyContent: "center" }}>
              <Button type="submit" color="success" data-cy="submit">
                {isBackupForm ? "Save a backup file" : "Submit"}
              </Button>
            </CardFooter>
          </Form>
        )}
      </Formik>
    </Card>
  );
}

SecretKeyForm.propTypes = {
  onSubmit: func.isRequired,
  isBackupForm: bool,
};

SecretKeyForm.defaultProps = {
  onSubmit: () => {},
  isBackupForm: false,
};

export default SecretKeyForm;
